const CardItemLimit = 3;

/* eslint-disable-next-line */
export { CardItemLimit };
